<template>
  <div v-if="devicecategory">
    <app-header :title="(originalName) ? 'Edit '+ originalName: 'New Device Category'" subtitle="Device Category">
      <b-button variant="primary" :disabled="!devicecategory.name" @click="save()">
        Save Changes
      </b-button>
      <cancel-button />
    </app-header>
    <b-container>
      <b-row>
        <b-col md="4">
          <b-form name="editorForm">
            <b-form-group>
              <label>Name</label> <i class="fa fa-asterisk" style="font-size:8px;color:red" />
              <b-form-input
                v-model="devicecategory.name"
                type="text"
                required
              ></b-form-input>
            </b-form-group>
          </b-form>
        </b-col>
        <b-col md="8"></b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import $api from '@/services/api';
import CancelButton from '@/components/CancelButton';
import AppHeader from '@/components/AppHeader';

export default {
  components: {
    AppHeader,
    CancelButton,
  },

  data() {
    return {
      originalName: null,
      devicecategory: null,
    };
  },

  created() {
    this.refreshData();
  },

  methods: {
    async refreshData() {
      if (this.$route.query.id) {
        this.devicecategory = await $api.get(`/v1/internal/devicecategories/${this.$route.query.id}`);
        this.originalName = this.devicecategory.name;
      } else {
        this.devicecategory = {};
      }
    },

    async save() {
      let devicecategory;
      if (this.devicecategory.id) {
        devicecategory = await $api.put(`/v1/internal/devicecategories/${this.devicecategory.id}`, this.devicecategory);
      } else {
        devicecategory = await $api.post('/v1/internal/devicecategories', this.devicecategory);
      }
      this.$router.push({
        name: 'devicecategory-detail',
        params: devicecategory,
      });
    },
  },
};
</script>
